module.exports = __webpack_public_path__ + "assets/img/smartTV-module5-2.c0898115.jpg";